import {
  Country,
  de_BetterDocRecommendationState,
  de_BetterDocRecommendationStateGroup,
  de_BetterDocSecondOpinion,
} from "@/types/__generated__/union-types"

export const BETTER_DOC_ROUTE_PATH = "/admin/better-doc"

export const SESSION_ID_SEARCH_PARAMETER = "sessionId"

export const GRAPHQL_INT_MAXIMUM = 2_147_483_647

export const LOOKUP_IDENTIFIER_MAXIMUM_LENGTH = 100

export const LIST_PAGE_SIZE = 50

export const BODY_COLLAPSE_THRESHOLD_CHARACTERS = 100_000

export const EMPTY_VALUE_PLACEHOLDER = "-"

export const BETTER_DOC_TABS = ["sessions", "queryBetterDoc", "anamnesisInfoSchemas", "exchanges", "testCases"] as const

export type BetterDocTab = (typeof BETTER_DOC_TABS)[number]

export const BETTER_DOC_RECOMMENDATION_STATE_GROUPS: ReadonlyArray<de_BetterDocRecommendationStateGroup> = [
  "OPEN",
  "RECOMMENDED",
  "SELECTED",
  "REJECTED",
  "FAILED",
]

export const DEFAULT_RECOMMENDATION_STATE_GROUP: de_BetterDocRecommendationStateGroup = "OPEN"

export const BETTER_DOC_STATES_BY_STATE_GROUP: Record<
  de_BetterDocRecommendationStateGroup,
  ReadonlyArray<de_BetterDocRecommendationState>
> = {
  OPEN: ["TRIAGING", "PENDING", "ADMITTING", "ADMITTED", "RESEARCHING"],
  RECOMMENDED: ["RECOMMENDED"],
  SELECTED: ["MEDIC_SELECTED", "MEDIC_CONFIRMED"],
  REJECTED: ["REJECTED"],
  FAILED: ["NO_SERVICE", "SERVICE_TRIAGE_FAILED", "ADMISSION_FAILED", "RESEARCH_FAILED"],
}

export const BETTER_DOC_SECOND_OPINIONS: ReadonlyArray<de_BetterDocSecondOpinion> = [
  "NOT_APPLICABLE",
  "REQUIRED",
  "NOT_REQUIRED",
]

export const DEFAULT_SECOND_OPINION: de_BetterDocSecondOpinion = "NOT_APPLICABLE"

export const DEFAULT_UPDATED_AFTER_DATE = new Date(2026, 0, 1)

export const INSURANCE_COUNTRIES: ReadonlyArray<Country> = ["CH", "DE"]

export const DEFAULT_INSURANCE_COUNTRY: Country = "DE"

export const RECOMMENDED_BETTER_DOC_STATES: ReadonlyArray<de_BetterDocRecommendationState> = [
  "RECOMMENDED",
  "MEDIC_SELECTED",
  "MEDIC_CONFIRMED",
]

export const REFERRAL_SLIP_DEFAULT_DURATION_DAYS = 7

export const MEDIC_SELECTION_DEFAULT_DURATION_DAYS = 7
